import type { IBariPreDietPlanAppointmentData } from '@common/validation/customControls/bariPre/bariPreDietPlanAppointment/v1/bariPreDietPlanAppointmentSchemaV1';

export const initialData: IBariPreDietPlanAppointmentData = {
    recipient: {
        organizationId: null,
        practitionerId: null,
    },
    toelichting: null,
};
